import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

const TOPBAR_HEIGHT = 5
const SIDEBAR_WIDTH = 200
export const StyleTopBar = styled.div`
  inset: 0;
  position: fixed;
  height: ${TOPBAR_HEIGHT}vh;
  background-color: ${(props: any) => props.theme.colors.white};
  z-index: 10;
  border: 2px solid ${(props: any) => props.theme.colors.borderColor};
  border-width: 1.6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px 0 80px;
  @media (max-width: 768px) {
    padding: 4px 8px;
    height: 4vh;
  }
`

export const StyleContainer = styled.div`
  display: flex;
`

export const StyleSideBar = styled.div<{ collapsed?: boolean }>`
  position: fixed;
  flex: 0.7;
  width: ${({ collapsed }) => (collapsed ? '24px' : `${SIDEBAR_WIDTH}px`)};
  height: 100vh;
  overflow-y: scroll;
  background-color: ${(props: any) => props.theme.colors.white};
  border: 2px solid ${(props: any) => props.theme.colors.borderColor};
  border-width: 1.6px;
  padding: ${({ collapsed }) => (collapsed ? '20px 10px' : '0px 20px')};
  flex-shrink: 0;
  z-index: 10000;
  transition:
    width 0.3s ease,
    padding 0.3s ease;
  ${(props: any) =>
    props.collapsed &&
    css`
      align-items: center;
      justify-content: center;
    `}

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 768px) {
  }
`
export const StyleChildren = styled.div<{ collapsed?: boolean }>`
  margin-left: ${SIDEBAR_WIDTH + 45}px;
  /* height: calc(100vh - ${TOPBAR_HEIGHT}vh); */
  height: auto;
  overflow-y: scroll;
  transform: translateY(${TOPBAR_HEIGHT}vh);
  background-color: ${(props: any) => props.theme.colors.childrenColor};
  padding: 20px;
  padding-right: 20px;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;

  @media (max-width: 768px) {
    padding: 5px;
  }
  ${({ collapsed }) =>
    collapsed &&
    css`
      margin-left: 45px;
    `};

  @media (max-width: 768px) {
    ${({ collapsed }) =>
      !collapsed &&
      css`
        margin: 0;
      `}
  }
`

export const LogoWrapper = styled.div`
  cursor: pointer;
  @media (max-width: 768px) {
    transform: translateX(-75px);
  }
`
export const Logo = styled.img`
  width: 100%;
`

export const TopbarRightWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
`

export const SidbarListWrapper = styled.ul<{ collapsed?: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 25px;

  &::-webkit-scrollbar {
    visibility: hidden;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;

  & > :nth-of-type(1) svg,
  & > :nth-of-type(2) svg,
  & > :last-child svg {
    stroke: #343f52;
  }

  ${(props: any) =>
    props.collapsed &&
    css`
      align-items: center;
    `}
`

export const LinkWrapper = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  ${({ active, theme }: any) =>
    active &&
    css`
      svg {
        stroke: ${theme.colors.primary};
      }
    `}
`

export const SidebarList = styled('li', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>`
  color: ${(props: any) => props.theme.colors.text};
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  vertical-align: middle;
  line-height: 20px;

  ${({ active, theme }: any) =>
    active &&
    `
      color: ${theme.colors.primary};
    `}
`
